// Import necessary modules and components
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { StatusMenu } from "../../api/StatusMenu";
import { AuthFetchAPI } from "../../api/Auth";
import { MachinesFetchAPI } from "../../api/Machines";
import ErrorAlert from '../Alerts/ErrorAlert';

// Function to validate the session
async function validSession() {
    // Initialize variables for machine, business, branch office, logo, and other parameters
    let machine = "";
    let business = "";
    let branchoffice = "";
    let logo = "";
    let params = false;
    let token = localStorage.getItem("x-access-token");

    // Check if the logo exists in localStorage and retrieve it
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo');
    }

    // Validate if the required tokens and data exist in localStorage
    if (localStorage.getItem("x-access-token") == "" || localStorage.getItem("x-access-token") == undefined || localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {
        // Do nothing if any required data is missing
    } else {
        // Set parameters to true and parse the necessary data from localStorage
        params = true;
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
        machine = JSON.parse(localStorage.getItem('machine'));
        business = JSON.parse(localStorage.getItem("business"));
    }


    let data = "";

    // Function to validate the token
    const validToken = async () => {
        
        try {
            // Call the API to validate the token
            const response = await AuthFetchAPI.validToken(localStorage.getItem('x-access-token'));
            if (response.data !== true) {
                // If the token is invalid, sign out the user
                signout();
            }
        } catch (err) {
            console.log(err);
            // Solo un 401 (token caducado) es una sesion invalida. Sin red, timeout o error del servidor no se
            // sabe nada del token: cerrar sesion aqui liberaba la caja y borraba el almacenamiento por un
            // simple corte de internet.
            if (err?.response?.status === 401) {
                signout();
            }
        }
    };

    // Function to log out of the payment post
    const signout = async () => {
        // Retrieve the machine token and machine data from localStorage
        let machine_token = localStorage.getItem('x-access-machine-token');
        let machine = JSON.parse(localStorage.getItem('machine_original'));

        // Log out the machine
        try {
            const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);

            if (response.data.success == true) {
                localStorage.clear();
                // Redirect the user to the login page
                ErrorAlert("Sesión expirada", "Por favor inicie sesión nuevamente", "warning");
                setTimeout(() => { window.location.href = '/machines/login/' + business.code; }, 3000);
            }
        } catch (err) {
            // Handle errors during logout and redirect the user to the login page
            console.log(err);
            localStorage.clear();
            ErrorAlert("Sesión expirada", "Por favor inicie sesión nuevamente", "warning");
            setTimeout(() => { window.location.href = '/machines/login/' + business.code; }, 3000);
        }
    };

    // Validate the token
    await validToken();
    return data;
}

// Export the validSession function as the default export
export default validSession;